/* See src/components/tabs.scss for usage */

$(document).ready(function() {
	attachTabs();
});

function attachTabs() {
	$('.tabs .tab').on('click', function() {
		$(this).parent().find('.tab').removeClass('chosen');
		$(this).addClass('chosen');
		var group = $(this).parent('.tabs').data('tabgroup');
		var choice = $(this).data('tab');

		$('.tab_content_area[data-group="' + group + '"] > .tab_content').hide();
		var loadTab = $('.tab_content_area[data-group="' + group + '"] > .tab_content[data-tab="' + choice + '"]');
		loadTab.show();
	});
}